/**
 * CARTAL launch discount helper (iter106).
 *
 * All published prices (subscriptions, boost tiers, escrow fee) reflect a
 * 50% launch-only discount. We show the buyer the original price crossed
 * out + the savings amount so they see the value they're getting, matching
 * the pattern already established on the DealCompletionPage escrow tile.
 *
 * iter163 — Launch discount window closed. Flag flipped to `false` so
 * every "50% OFF · LAUNCH" / "15% OFF · LAUNCH" ribbon and strikethrough
 * disappears app-wide. Buyers pay the published price with no additional
 * discount surface. The two currently-active launch promotions (Yanbu
 * Dealers 3-month free and CARTAL Plus Individual 6-month free) live in
 * their own dedicated modules and are unaffected.
 */

export const LAUNCH_ACTIVE = false;
export const LAUNCH_DISCOUNT_PCT = 50; // percent off (e.g., 50 → half price)

/**
 * Compute the display prices for a launch-discounted SKU.
 * @param {number} currentSar the price the buyer will actually pay today
 * @returns {{
 *   current: number,   // the discounted price (what the buyer pays)
 *   original: number,  // the full price shown crossed out
 *   savings: number,   // absolute savings in SAR
 *   percent: number,   // percentage saved (integer)
 *   active: boolean,   // whether the launch discount is currently active
 * }}
 */
export function launchPrice(currentSar) {
  const cur = Number(currentSar) || 0;
  if (!LAUNCH_ACTIVE || cur <= 0) {
    return { current: cur, original: cur, savings: 0, percent: 0, active: false };
  }
  // If the discount is 50%, original = current × 2. General formula:
  // original = current / (1 - pct/100)
  const original = Math.round(cur / (1 - LAUNCH_DISCOUNT_PCT / 100));
  return {
    current: cur,
    original,
    savings: original - cur,
    percent: LAUNCH_DISCOUNT_PCT,
    active: true,
  };
}
